import React from "react";
import {Card} from "react-bootstrap";
import {Stats} from "../../types/Types";
import {formatDateDDMMYYYY, formatNumber, formatNumberToDays} from "../../util/Util";

interface Props {
    stats: Stats | undefined;
    socialDisabled: boolean;
    isFirstCard?: boolean;
}

function StatsWidget(props: Props) {
    if (!props.stats) {
        return (
            <Card className={`mb-3 ${props.isFirstCard && props.socialDisabled ? "mt-3" : ""}`}>
                <Card.Header>
                    <div><b>'Spoons Tracker Stats</b></div>
                </Card.Header>
                <Card.Body style={{padding: "1em"}}>
                    <div className={'loading'}>Loading...</div>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className={`mb-3 ${props.isFirstCard && props.socialDisabled ? "mt-3" : ""}`}>
            <Card.Header>
                <div><b>'Spoons Tracker Stats</b></div>
            </Card.Header>
            <Card.Body style={{padding: "1em"}}>
                <ul className={"bullet-points"}>
                    <li><div className={"mb-2"}><b>{formatNumber(props.stats.activeUsers)}</b> users, with <b>{formatNumber(props.stats.recentUsers)}</b> active in the last week.</div></li>
                    <li><div className={"mb-2"}><b>{formatNumber(props.stats.visits)}</b> visits recorded.</div></li>
                    <li><div className={"mb-2"}><b>{formatNumber(props.stats.stays || 0)}</b> stays recorded.</div></li>
                    {!props.socialDisabled && <li><div className={"mb-2"}><b>{formatNumber(props.stats.sessions)}</b> check-ins, for a total time of <b>{formatNumberToDays(props.stats.hoursCheckedIn)} days.</b></div></li>}
                    {!props.socialDisabled && <li><div className={"mb-2"}><b>{formatNumber(props.stats.mostSimultaneousCheckIns || 0)}</b> record simultaneous check-ins{props.stats.mostSimultaneousCheckInsAt ? <> on <b>{formatDateDDMMYYYY(props.stats.mostSimultaneousCheckInsAt)}</b></> : ""}.</div></li>}
                    {!props.socialDisabled && <li><div className={"mb-2"}><b>{formatNumber(props.stats.comments)}</b> pub page comments.</div></li>}
                    {!props.socialDisabled && <li><div><b>{formatNumber(props.stats.photos)}</b> photos uploaded.</div></li>}
                </ul>
            </Card.Body>
        </Card>
    );
}

export default StatsWidget;
